export const CV_EDITOR_DEFAULT_STATUS = "new";

export const createEditorMetaState = () => ({
  draftId: null,
  status: CV_EDITOR_DEFAULT_STATUS,
  completionScore: 0,
  isSaving: false,
  isLoading: false,
});

export const applyLoadedDraftMeta = (data, fallbackId = null) => ({
  draftId: data?._id || fallbackId,
  status: data?.status || "draft",
  completionScore: Number.parseInt(data?.completion_score, 10) || 0,
});
